import { fontFamilyEN, fontFamilyAR } from "./font";
import { arabicLang } from "./constants";

export function getFontFamily(selectedLang) {
  if (selectedLang === arabicLang) {
    return fontFamilyAR;
  }
  return fontFamilyEN;
}
